import { render, staticRenderFns } from "./input-chip.vue?vue&type=template&id=e2358dfe&scoped=true&"
import script from "./input-chip.vue?vue&type=script&lang=js&"
export * from "./input-chip.vue?vue&type=script&lang=js&"
import style0 from "./input-chip.vue?vue&type=style&index=0&id=e2358dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2358dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VChipGroup,VTextField})
